import { tokens } from '@/design';
import { tableFrameStyleMeta } from './tableFrameStyles';
import type { TableFrameStyleId } from './layoutTypes';

export function TableFrameStyleThumbnail({
  styleId,
}: {
  readonly styleId: TableFrameStyleId;
}) {
  const style = tableFrameStyleMeta(styleId);
  const rows = [
    ['1202', 'Land'],
    ['1203', 'Water'],
    ['1204', 'Urban'],
    ['1205', 'Land'],
  ] as const;
  const cycle = style.background1Count + style.background2Count;
  return (
    <span
      aria-hidden
      style={{
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        width: '100%',
        border: `${tokens.border.width.thin}px solid ${style.frameBorder}`,
        fontSize: tokens.font.size.xs,
        overflow: 'hidden',
      }}
    >
      {['Field1', 'Field2'].map((heading) => (
        <strong
          key={heading}
          style={{
            padding: tokens.space[1],
            color: style.headingColor,
            background: style.headingBackground,
            border: `${tokens.border.width.thin}px solid ${style.headingBorder}`,
            borderBottom: `${tokens.border.width.thin}px solid ${style.headingUnderline}`,
            textAlign: 'center',
          }}
        >
          {heading}
        </strong>
      ))}
      {rows.flatMap((row, rowIndex) => {
        const first = rowIndex % cycle < style.background1Count;
        return row.map((value, columnIndex) => (
          <span
            key={`${rowIndex}-${columnIndex}`}
            style={{
              padding: tokens.space[1],
              background: first
                ? style.rowBackground1
                : style.rowBackground2,
              border: `${tokens.border.width.thin}px solid ${style.rowBorder}`,
              textAlign: columnIndex === 0 ? 'right' : 'left',
            }}
          >
            {value}
          </span>
        ));
      })}
    </span>
  );
}
